import React from "react";
import "./experience.scss";
import GeneralCertification from "./GeneralCertification";
import SpecialityBoard from "./SpecialityBoard";
import ProviderEducation from "./ProviderEducation";
import Association from "./Association";

const Experience = () => {
  return (
    <div className="experience-content container-body">
      <div className="full-width-container display-flex col-md-12">
        <ProviderEducation />
      </div>
      <div className="certAssociation-title col-md-12">
        <h3>Certifications and Associations</h3>
      </div>
      <div className="full-width-container display-flex">
        <div className="speciality-board col-md-6">
          <SpecialityBoard />
        </div>

        <div className="speciality-board col-md-6">
          <GeneralCertification />
        </div>
      </div>
      <div className="full-width-container display-flex">
       <div className="col-md-6"><Association/></div>
    <div className="col-md-6"></div>

 </div>   
  </div>
  );
};
export default Experience;
